import { enviroments } from '@infrastructure/enviroments';
import { base } from '@service/base';

import { UpsellFlow } from 'src/models';

const BASE_URL = enviroments.BASE_URL;

export async function createUpsellFlow(
  request: UpsellFlow.CreateUpsellFlowDTO
): Promise<void> {
  await base({
    baseURL: BASE_URL,
    url: `/funnel/flow`,
    method: 'POST',
    data: request,
  });
}
